import { useState } from 'react';
import type {
  ModalState,
  ProjectFormData,
} from '../interfaces/ui/addProjectModal';

export function useModalState() {
  const [modalState, setModalState] = useState<ModalState>({
    isOpen: false,
    isEditing: false,
    editingProjectId: null,
    editingProjectData: null,
    initialErrors: {},
  });

  const openModal = (initialData?: ProjectFormData) => {
    setModalState(prev => ({
      ...prev,
      isOpen: true,
      isEditing: !!initialData,
      editingProjectData: initialData || null,
      initialErrors: {},
    }));
  };

  const closeModal = () => {
    setModalState(prev => ({
      ...prev,
      isOpen: false,
      isEditing: false,
      editingProjectId: null,
      editingProjectData: null,
      initialErrors: {},
    }));
  };

  const setEditingProjectId = (id: string | null) =>
    setModalState(prev => ({ ...prev, editingProjectId: id }));

  const setModalErrors = (errors: Record<string, string>) =>
    setModalState(prev => ({ ...prev, initialErrors: errors }));

  return {
    modalState,
    openModal,
    closeModal,
    setEditingProjectId,
    setModalErrors,
  };
}
